import React from 'react';
import Skeleton from 'components/Skeleton';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import useStatisticsList from 'customHooks/useStatisticsList';
import CountUp from 'react-countup';
import { FaUsers, FaUserShield } from 'react-icons/fa';
import { ImUser } from 'react-icons/im';
import { HiUsers } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { showLoader } from 'utils';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: '1rem',
  },
  filter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  card: {
    padding: '20px',
    marginTop: '20px',
    textAlign: 'center',
    color: '#fff',
    maxHeight: '120px',
    minHeight: '120px',
    minWidth: '240px',
  },
  count: {
    fontSize: '35px',
  },
  cardInnerContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  countContainer: {
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  cardWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2%',
    flexWrap: 'wrap',
  },
});

const Statistics = () => {
  const classes = useStyles();
  const loading = useSelector(state => state.statistics.loading);
  const statisticsList = useStatisticsList();
  console.log(statisticsList, 'statisticsList');
  const { totalUsers, standardUsers, adminUsers, partnerUsers, statsData } =
    statisticsList;
  console.log(loading, 'statsData');
  return (
    <Skeleton>
      <Grid container spacing={3}>
        <div className={classes.cardWrapper}>
          <Card
            className={classes.card}
            style={{ backgroundColor: 'rgb(245, 157, 74)' }}
          >
            <div className={classes.cardInnerContainer}>
              <div className={classes.countContainer}>
                <CountUp
                  className={classes.count}
                  start={0}
                  end={totalUsers}
                  duration={1.5}
                />
                <h5>Total Users</h5>
              </div>
              <div>
                <FaUsers size={50} />
              </div>
            </div>
          </Card>
          <Card
            className={classes.card}
            style={{ backgroundColor: 'rgb(60, 112, 147)' }}
          >
            <div className={classes.cardInnerContainer}>
              <div className={classes.countContainer}>
                <CountUp
                  className={classes.count}
                  start={0}
                  end={standardUsers}
                  duration={1.5}
                />
                <h5>Standard Users</h5>
              </div>
              <div>
                <ImUser size={50} />
              </div>
            </div>
          </Card>
          <Card
            className={classes.card}
            style={{ backgroundColor: 'rgb(231, 113, 125)' }}
          >
            <div className={classes.cardInnerContainer}>
              <div className={classes.countContainer}>
                <CountUp
                  className={classes.count}
                  start={0}
                  end={adminUsers}
                  duration={1.5}
                />
                <h5>Admin Users</h5>
              </div>
              <div>
                <FaUserShield size={50} />
              </div>
            </div>
          </Card>
          <Card
            className={classes.card}
            style={{ backgroundColor: 'rgb(242, 200, 59)' }}
          >
            <div className={classes.cardInnerContainer}>
              <div className={classes.countContainer}>
                <CountUp
                  className={classes.count}
                  start={0}
                  end={partnerUsers}
                  duration={1.5}
                />
                <h5>Partner Users</h5>
              </div>
              <div>
                <HiUsers size={50} />
              </div>
            </div>
          </Card>
        </div>
        <Grid item xs={12}>
          <TableContainer className={classes.container} component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead className={classes.tabelHeaderBackground}>
                <TableRow>
                  <TableCell
                    align="center"
                    className={classes.tabelHeaderColor}
                  >
                    New WBO Users
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tabelHeaderColor}
                  >
                    Old WBO Users
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tabelHeaderColor}
                  >
                    State
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tabelHeaderColor}
                  >
                    Total Logs
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tabelHeaderColor}
                  >
                    Total Users
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {statsData &&
                  statsData.map(stats => (
                    <TableRow key={stats._id} className={classes.center}>
                      <TableCell align="center">{stats.newWBOUsers}</TableCell>
                      <TableCell align="center">{stats.oldWBOUsers}</TableCell>
                      <TableCell align="center">{stats.state}</TableCell>
                      <TableCell align="center">{stats.totalLogs}</TableCell>
                      <TableCell align="center">{stats.totalUsers}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      {showLoader(loading)}
    </Skeleton>
  );
};

export default Statistics;
